<template>
  <!--
    BEGIN::Modified.by.KWShin.2024.08.30.
    motletOptions에 추가적인 설정을 통합하여 전달.
  -->
  <!--motlet-neo :options="motletOptions" dense-->
  <motlet-neo :options="mergedMotletOptions" dense>
    <!-- FINISH::Modified.by.KWShin.2024.08.30. -->
    <template v-slot:content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <field-selectable-grid
        :sstmId="params.sstmId"
        :code="props.motlet.settings.grid.code"
        :event-code="props.motlet.settings.grid.eventCode"
        :selected="props.motlet.settings.grid.selectedFields"
        :height="params.height"
        :timestamp="timestamp"
        :clickRow="clickRow"
        :onFetch="onFetch"
        :items.sync="items"
      />
    </template>
  </motlet-neo>
</template>

<script>
// Added.by.KWShin2024.08.30.
import { merge } from 'lodash';
import FieldSelectableGrid from '../../../components/abap/FieldSelectableGridNeo';

export default {
  components: {
    FieldSelectableGrid,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    clickRow: {
      type: Function,
      default() {
        return function() {};
      },
    },
    onFetch: {
      type: Function,
      default() {
        return function() {};
      },
    },
  },
  data() {
    return {
      motletOptions: {
        id: 'detailview/abap/dumpLog/sysLog/SysLogGrid',
        title: 'syslog.grid.title',
        settings: { grid: { use: true, code: 'G_ABAP_SYS_LOG', eventCode: 'ABAP_SYS_LOG' } },
        descendant: {
          systemId: this.params.sstmId,
        },
      },
      items: [],
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.08.30.
    // 기존의 motletOptions에 params를 통해 넘어온 motletOptions 옵션을 통합하여 준다.
    mergedMotletOptions() {
      return merge({}, this.motletOptions, this.params.motletOptions);
    },
    // FINISH::Added.by.KWShin.2024.08.30.
  },
  methods: {},
};
</script>
